<div class="raptor-section-container grid">
  <div
    class="raptor-section-panel cell cell-small-col-span-6"
    [ngClass]="{
      'cell-large-col-span-12': section.settings.size !== 'small' && section.settings.size !== 'medium',
      'cell-large-col-span-8 cell-medium-col-span-6': section.settings.size === 'medium',
      'cell-large-col-start-3 cell-medium-col-start-2': section.settings.size === 'medium' && (!section.settings.align || section.settings.align === 'center'),
      'cell-large-col-start-5 cell-medium-col-start-4': section.settings.size === 'medium' && section.settings.align === 'right',
      'cell-large-col-span-6 cell-medium-col-span-4': section.settings.size === 'small',
      'cell-large-col-start-4 cell-medium-col-start-3': section.settings.size === 'small' && (!section.settings.align || section.settings.align === 'center'),
      'cell-large-col-start-7 cell-medium-col-start-5': section.settings.size === 'small' && section.settings.align === 'right'
    }"
  >

    <!-- banner -->
    <div *ngIf="section.settings.banner" [innerHTML]="section.settings.banner" class="raptor-section-banner"></div>
    <!-- heading inside -->
    <div class="grid" *ngIf="section.heading && section.settings.header === 'outside'">
      <div class="cell cell-large-col-span-12 cell-medium-col-span-7">
        <h2 class="margin-bottom-xsmall padding-horizontal-medium">{{ section.heading }}</h2>
      </div>
    </div>

    <div class="raptor-section-content" [class]="sectionClass" [ngClass]="{'padding-medium': section.settings.card, 'margin-bottom-xmedium': section.heading && section.settings.header === 'outside' }">
      <div *ngIf="section.info && section.info.settings && section.info.settings.align === 'top'" class="margin-bottom-small">
        <open-raptor-info [info]="section.info" [form]="form"></open-raptor-info>
      </div>

      <div class="grid">
        <!-- hero image cell -->
        <div
          *ngIf="heroType"
          class="raptor-section-hero cell cell-small-col-span-6"
          [ngClass]="{
            'cell-medium-col-span-1 cell-large-col-span-2': section.settings.hero
          }"
        >
          <div class="lottie-player-container" *ngIf="heroType === 'json'">
            <lottie-player [src]="section.settings.hero" background="transparent" autoplay></lottie-player>
          </div>
          <div class="lottie-player-container" *ngIf="heroType !== 'json'">
            <open-svg-icon name="{{ section.settings.hero }}" [class]="section.settings.size === 'small' ? 'small' : 'large'"></open-svg-icon>
          </div>
        </div>

        <!-- questions cell -->
        <div
          class="raptor-section-questions cell cell-small-col-span-6"
          [ngClass]="{
            'cell-medium-col-span-7 cell-large-col-span-10': section.settings.hero,
            'cell-medium-col-span-8 cell-large-col-span-12': !section.settings.hero
          }"
        >
          <!-- heading inside -->
          <div class="grid" *ngIf="section.heading && section.settings.header !== 'outside'">
            <div class="cell cell-large-col-span-12 cell-medium-col-span-7">
              <h2 [ngClass]="section.info && section.info.settings && section.info.settings.align === 'under_heading' ? 'padding-bottom-none' : 'padding-bottom-xmedium'">{{ section.heading }}</h2>
            </div>
          </div>
          <div *ngIf="section.info && section.info.settings && section.info.settings.align === 'under_heading'" class="margin-bottom-small">
            <open-raptor-info [info]="section.info" [form]="form"></open-raptor-info>
          </div>
          <p
            *ngIf="section.subtext"
            class="margin-bottom-medium"
            [innerHTML]="section.subtext"
            class="raptor-section-subtext"
            [ngClass]="{
              'text-left': !section.settings || !section.settings.align || section.settings.align === 'left',
              'text-center': section.settings.align === 'center',
              'text-right': section.settings.align === 'right'
            }"
          ></p>

          <div class="raptor-section-column-container grid" [ngClass]="{'centered': (questions && questions.length === 1 && !section.heading && !section.subtext)}">
            <div
              class="raptor-section-column-panel cell cell-small-col-span-6"
              [ngClass]="{
                'cell-large-col-span-12': section.settings.column_size !== 'small' && section.settings.column_size !== 'medium',
                'cell-medium-col-span-6 cell-large-col-span-8': section.settings.column_size === 'medium',
                'cell-medium-col-span-4 cell-large-col-span-6': section.settings.column_size === 'small'
              }"
            >
              <div class="grid raptor-section-questions-grid" *ngFor="let row of questions">
                <div
                  *ngFor="let question of row"
                  [class]="raptorDataService.columnLayoutClass(columns, question)"
                > 
                    <ng-container *ngIf="question && question.type" [ngSwitch]="question.layout">
                      <ng-container *ngSwitchCase="'review'">
                        <open-raptor-question-review [element]="question" [form]="form" [context]="'review'"></open-raptor-question-review>
                      </ng-container>

                      <div *ngSwitchCase="'payment'">
                        <open-raptor-payment [question]="question" [form]="form"></open-raptor-payment>
                      </div>

                      <ng-container *ngSwitchDefault>
                        <open-raptor-question [question]="question" [form]="form" [submitted]="raptorStepService.submitted"></open-raptor-question>
                      </ng-container>
                    </ng-container>

                    <ng-container *ngIf="question && question.component" [ngSwitch]="question.component">
                      <open-raptor-component [form]="form" [type]="question.component" [config]="question"></open-raptor-component>
                    </ng-container>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div *ngIf="section.info && (!section.info.settings || (section.info.settings.align !== 'top' && section.info.settings.align !== 'under_heading'))">
        <open-raptor-info [info]="section.info" [form]="form" [ngClass]="{'section-info': true}"></open-raptor-info>
      </div>

      <!-- ERRORS - show errors in FormData -->
      <div *ngIf="section.errors" class="open-form-info is-error padding-medium margin-top-medium">
        <p class="text-left" *ngFor="let error of section.errors" [innerHTML]="error"></p>
      </div>

      <!-- Section disclaimer -->
      <p *ngIf="section.disclaimer && section.disclaimer.content" class="text-small" [innerHTML]="section.disclaimer.content"></p>
    </div>

  </div>
</div>
